import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'rating-display',
  templateUrl: 'rating-display.html'
})
export class RatingDisplayComponent implements OnInit {
  @Input() rating: string;
  ratings = [];
  ratingDataLoaded = false;

  constructor() {}

  ngOnInit() {
    let max = parseInt(this.rating) + 1;
    for (let i = 1; i < max; i++) {
      this.ratings.push('x');
    }
    this.ratingDataLoaded = true;
  }
}



// WEBPACK FOOTER //
// ./src/shared/rating/rating-display.ts